import GenericTypesService from 'api/genericTypes/GenericTypesService';
import { GenericType } from 'api/genericTypes/enums/GenericType';

const CHARGES_FILTERS_CACHE_KEY = 'CHARGESFILTER-0';

let cachedFuelTypeId: string | null = null;

const resolveFuelTypeId = async (): Promise<string | null> => {
	if (cachedFuelTypeId) return cachedFuelTypeId;
	try {
		const types = await GenericTypesService.catalogCharge();
		const fuel = (types || []).find(x => x.label === GenericType.FUEL || x.name === GenericType.FUEL);
		cachedFuelTypeId = fuel?.value ?? null;
	} catch {
		// ignore
	}
	return cachedFuelTypeId;
};

type Options = {
	dateFrom: Date;
	dateTo: Date;
	fuelTypeLabel: string;
	vehicle?: { id: string; name: string };
};

export const openFuelCharges = async ({ dateFrom, dateTo, fuelTypeLabel, vehicle }: Options) => {
	const typeId = await resolveFuelTypeId();
	try {
		const next: Record<string, unknown> = {
			startDate: dateFrom,
			endDate: dateTo,
			vehiclesInactive: false,
		};
		if (vehicle) {
			const raw = localStorage.getItem(CHARGES_FILTERS_CACHE_KEY);
			const existing = raw ? JSON.parse(raw) : {};
			Object.assign(next, existing, {
				vehicleId: vehicle.id,
				vehicleName: vehicle.name,
				startDate: dateFrom,
				endDate: dateTo,
				vehiclesInactive: false,
				page: 1,
				scrollToItemId: undefined,
			});
		}
		if (typeId) {
			next.typeId = typeId;
			next.type = GenericType.FUEL;
			next.typeName = fuelTypeLabel;
		}
		localStorage.setItem(CHARGES_FILTERS_CACHE_KEY, JSON.stringify(next));
	} catch {
		// ignore
	}
	window.open('/charges', '_blank');
};

export default openFuelCharges;
